module.exports = __webpack_public_path__ + "img/sling.f25a3793.png";